







import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectStatus from "../components/ProjectStatus.vue";
import VNameAndAvatar from "./VNameAndAvatar.vue";

export interface Props {
  name: string;
  icon: string;
  status: string;
}

@Component({
  components: {
    VNameAndAvatar,
    ProjectStatus
  }
})
export default class ProjectBar extends Vue {
  @Prop({ required: true }) name!: string;
  @Prop({ required: true }) icon!: string;
  @Prop({ required: true }) status!: string;
}
